import React from "react";
import TimelyDisclosureTable from "../components/TimelyDisclosureTable";
import SecurityReportTable from "../components/SecurityReportTable";
import PressReleaseTable from "../components/PressReleaseTable";

const IRReportsTab = ({ secCode }) => {
    return (
        <div className="tabcontent">
            <PressReleaseTable secCode={secCode} />
            <TimelyDisclosureTable secCode={secCode} />
            <SecurityReportTable secCode={secCode} />
        </div>
    );
};

export default IRReportsTab;
